import { loadKindsRegistry } from '@/lib/nostr-kinds-registry'
import { TKindGroup } from '@/types/universe'

async function describeKind(kind: number): Promise<string> {
  const data = await loadKindsRegistry()
  const description = data?.kinds?.[`${kind}`]?.description?.trim()
  if (description) return description
  return `Kind ${kind}`
}

export async function getKindFilterOptions(): Promise<TKindGroup[]> {
  const { kindGroups } = window.hallway.universe
  if (!kindGroups || kindGroups.length === 0) return []

  return Promise.all(
    kindGroups.map(async (group) => ({
      label: group.label ?? (await describeKind(group.kinds[0])),
      kinds: [...group.kinds],
      disabled: group.disabled
    }))
  )
}
